import { useEffect, useState } from 'react';
import SystemConfigService from '../../../services/systemConfig_service';

const ScoreDateBase = (props) => {
  const [scoreDateBase, setScoreDateBase] = useState(null);
  const [scoreDateDay, setScoreDateDay] = useState('');
  const [scoreDateMonth, setScoreDateMonth] = useState('');

  const applyScoreDateBase = (config) => {
    const parsedDate = config?.ConfigValue ? new Date(config.ConfigValue) : null;
    const hasValidDate = parsedDate && !Number.isNaN(parsedDate.getTime());
    const day = config?.Day ?? (hasValidDate ? parsedDate.getDate() : '');
    const month = config?.Month ?? (hasValidDate ? parsedDate.getMonth() + 1 : '');

    setScoreDateBase(config);
    setScoreDateDay(day ? String(day) : '');
    setScoreDateMonth(month ? String(month) : '');
  };

  const loadScoreDateBase = async () => {
    props.setLoading(true);
    try {
      const config = await SystemConfigService.getScoreDateBase();
      if (props.logout(config)) return;
      applyScoreDateBase(config);
    } catch (e) {
      props.message(e?.message || e, 'error');
    } finally {
      props.setLoading(false);
    }
  };

  useEffect(() => { loadScoreDateBase(); }, []);

  const saveScoreDateBase = async () => {
    const lostAccess = await props.losesAccess?.();
    if (lostAccess) return;
    props.setLoading(true);
    try {
      const updated = await SystemConfigService.updateScoreDateBase(scoreDateDay, scoreDateMonth);
      if (props.logout(updated)) return;
      applyScoreDateBase(updated);
      props.message('Fecha de reinicio de puntaje actualizada con exito', 'success');
    } catch (e) {
      props.message(e?.message || e, 'error');
    } finally {
      props.setLoading(false);
    }
  };

  return {
    scoreDateBase,
    scoreDateDay,
    scoreDateMonth,
    setScoreDateDay,
    setScoreDateMonth,
    saveScoreDateBase,
  };
};

export default ScoreDateBase;
